import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import {
  patchResizeObserverToAvoidLoop,
  suppressBenignResizeObserverErrors,
} from "@/lib/resizeObserverLoop";

// Patch before React mounts so React Flow / charts never fire RO in-frame.
patchResizeObserverToAvoidLoop();
suppressBenignResizeObserverErrors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
